import { useContext } from 'react';
import AuthUserContext from './context';

export default function useUserProfile() {
	const { userProfile } = useContext(AuthUserContext);
	if (userProfile === undefined)
		throw new Error('useUserProfile must be used within AuthUserProvider');
	return userProfile;
}
